export default "__VITE_ASSET__cec4175c__"